import { createI18n } from 'vue-i18n'

import en from './locales/en'

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en
    },
    availableLocales: ['en']
})

export default i18n
